/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { useStateContext } from '../../../contexts/ContextProvider';
import '../../../App.css'
import { Spinner } from '../../../AbstractElements';
import Grow from '@mui/material/Grow';
import { getFireFightersShifts } from '../../../api/api';
import FireFightersShiftsTable from './FireFightersShiftsTable';

function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}
function isObject(item) {
  return (typeof item === 'object' && !Array.isArray(item) && item !== null);
}

const FireFightersShifts = () => {
  const { basictoaster, loading, setLoading, fireFightersShifts, setFireFightersShifts, getDateMinus8Days } = useStateContext();

  useEffect(() => {
    // set ab to state and use this new ab in this code
    let newAbortController = new AbortController()
    setLoading(true);
    // get the last 8 days firefighters shifts
    getFireFightersShifts(getDateMinus8Days(), newAbortController.signal).then((resp) => {
      if (!newAbortController.signal.aborted) {
        setFireFightersShifts(resp);
        setLoading(false);
      }
    }).catch((err) => {basictoaster("error", "Errore turni antincendio", err, () => {})});
    
    // Cleanup function to abort the request when the component unmounts
    return () => {
      newAbortController.abort();
    };
  }, [])

  // ALERT
  useEffect(() => {
    if (isObject(fireFightersShifts) && containsError(fireFightersShifts)) {
      basictoaster("error", "Errore turni antincendio", fireFightersShifts.Error, setFireFightersShifts)
    }
  }, [fireFightersShifts])

  return (
    <Fragment>
    <br />
      <Breadcrumbs phish mainTitle="Turni antincendio" parent="DomusVestra" title="Turni antincendio" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Grow in={true}><div>
            <Card>
              <CardBody>
                {/* <NewReq /><br /><br /> */}
                {loading ? (
                  <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-1' }} />
                  </div>
                ) : (
                  <>
                    <h2><b>Turni antincendio</b></h2><br />
                    <FireFightersShiftsTable />
                  </>
                )}
              </CardBody>
            </Card>
            </div></Grow>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default FireFightersShifts;